/**
 * Reads the first selected "area" filter value from table filter chips.
 * Chips may be `{ id, name }`, `{ value, label }`, a plain string id, etc.
 */
const getFirstSelectedAreaIdFromChips = (area: unknown[] | undefined): string | null => {
  if (area == null || area.length === 0) return null;
  const [first] = area;
  if (typeof first === 'string' || typeof first === 'number') return String(first);
  if (typeof first === 'object' && first !== null) {
    const o = first as Record<string, unknown>;
    const raw = o.id ?? o.value ?? o.name ?? first;
    if (typeof raw === 'string' || typeof raw === 'number') return String(raw);
  }
  return null;
};

export default getFirstSelectedAreaIdFromChips;
